import firebase from 'firebase';

import View from '../../../../../../_components/view/view.js';
import addPlayerTpl from './add-player.tpl.html';
import './add-player.styles.less';

class AddPlayerView extends View {

	constructor (data, options) {
		super(addPlayerTpl, data, options);
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			btnAddPlayer: '.btn-add-player',
			alertSuccess: '.alert-success'
		});
	}

	render(data) {
		super.render(data);
	}

	initializeEvents() {
		this.ui.btnAddPlayer.click(() => this.addPlayer());
	}

	addPlayer() {
		this.options.__player.ref.update({
			groupId: this.options.groupId
		})
		.then(() => {
			this.ui.btnAddPlayer.addClass('hidden');
			this.ui.alertSuccess.removeClass('hidden');
		});
	}

	/*onShow() {

	}*/


	remove() {
		super.remove();
	}

}

export default AddPlayerView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/groups/group/_modals/add-player-to-group-modal/add-player/add-player.view.js